import {axios as axios_new_api, axios_legacy as axios} from '@/store/config'
import { pick } from 'lodash'
import dayjs from 'dayjs';
import auth from '@/auth/index';
import VueCookies from 'vue-cookies'

export default {
  // state
  state : {
    profile: {},
    contactID: '',
    dashboardTimestamp: '',
    user:'',
    tooYoung: false,
    rules: {},
    first: false,
  },
  // getters
  getters : {
    profile: state => state.profile,
    contactID: state => state.contactID,
    user: state => state.user,
    rules: state => state.rules,
    claims: state => {
      if(state.profile.claims)
        return state.profile.claims;

      return [];
    },

    /**
     * If cividnumber starts with 9999 its a proteced number.
     */
    civicNumberIsProtected: state => {
      if(!state.profile.civicNumber)
        return;

      return state.profile.civicNumber.match(/^9999/) != null;
    },

    /**
     * Räkna ut åldern på den inloggade användaren
     */
    // används ingenstans och är inte pålitigt eftersom vissa användare är skyddade och då börjar åren på 9999
    // userAge: state => {

    //   return "Hej" + state.profile.civicNumber;
    //   if(!state.profile.civicNumber)
    //     return;

    //   return dayjs().diff(state.profile.civicNumber.substr(0,8), 'years')
    // }
  },

  // actions
  actions : {

    setSubscriptionsViewed ({ state }, siteInfoObj ) {
      return axios.post('/applicants/'+state.contactID+'/subscriptionsConfirm', {"siteinfo" : siteInfoObj})
        .then((response) => {
          return response;
        });
    },


    checkZipcode({ commit, dispatch }, zipcode){
      return new Promise((resolve, reject) => {
        axios.get( '/lists/postalCode/'+zipcode+'/city').then((response) => {
          resolve( { city: response.data });
        }).catch(reject)
      })
    },

    fetchPasswordRules ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {

        axios_new_api.get('/applicants/password/rules')
          .then((response) => {
            commit('setRules', response.data);
            //Return promise
            resolve(response.data);
          })
          .catch(reject);
      });
    },

    /**
     * Hämta datat om den inloggade användaren
     */
    fetchProfile ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {

        axios_new_api.get('/applicants/me', {
          headers: {
          Authorization: 'WebApi ' + auth.getToken(),
        }})
        .then((response) => {


          if(response.data.preferredContactMethod == "Ej angivet" || response.data.preferredContactMethod == "none" || response.data.preferredContactMethod == "(Ej angivet)") response.data.preferredContactMethod = "";
          if(response.data.email=="no-email@gavlegardarna.se") response.data.email='';
          //response.data.email=''
          //response.data.preferredContactMethod = "letter";
          /*if(this.first != true) {
            this.first = true;
            response.data.phoneMobile=""
          }*/
          if (response.data.defaultPhone == "mobilephone") response.data.defaultPhone = "phoneMobile";

          response.data.zipCode = response.data.zipCode.replace(/\s+/g, '');
          commit('setProfile', response.data);
          commit('setContactID', response.data);
          //Return promise
          resolve(response.data);
        })
        .catch(reject);
      });
    },
    fetchSpar ({ commit, dispatch }, civicnumber) {
      return new Promise((resolve, reject) => {
        axios_new_api.get('/applicants/lookup?ssn=' + civicnumber)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },




    /**
     * Uppdaterar profilen
     */
    saveProfile ({ state, commit, dispatch }, profile) {

      // Capitalize firstName and lastName
      const formattedProfile = {
        ...profile,
        firstName: profile.firstName
          ? profile.firstName.charAt(0).toUpperCase() + profile.firstName.slice(1)
          : '',
        lastName: profile.lastName
          ? profile.lastName.charAt(0).toUpperCase() + profile.lastName.slice(1)
          : '',
        postalAddress: profile.postalAddress
          ? profile.postalAddress.charAt(0).toUpperCase() + profile.postalAddress.slice(1)
          : ''
      };

      return axios_new_api.put('/applicants/?contactCode=me', pick(formattedProfile, ['firstName', 'lastName', 'email', 'phoneMobile', 'phoneHome', 'phoneMobile2', 'phoneMobile3', 'phoneWork', 'defaultPhone', 'postalAddress', 'postalAddress2', 'careOf', 'zipCode', 'city', 'preferredContactMethod']))
      .then((response) => {
        return response;
      });
    },

    confirmDetails ({ state, commit }) {
      return axios.post('/applicants/'+state.contactID+'/userDetailsConfirm', this.siteinfo)
        .then((response) => {
          return response;
        });
    },

    confirmOnboarding ({ state, commit }) {
      return axios_new_api.post('/applicants/onboardingConfirm', true)
        .then((response) => {
          return true;
        });
    },

    confirmMessagesOnboarding ({ state, commit }) {
      return axios_new_api.post('/applicants/messagesonboardingconfirm')
        .then(() => true);
    },

    createProfile ({ state, commit }, object) {
      var _commit = commit;

      return new Promise((resolve, reject) => {
        axios_new_api.post('/Applicants/', object )
        .then(function (response, commit) {
          _commit('setProfile', response.data);
          _commit('setUser', object.civicNumber);

          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data);
        })
      });
    },

    getContactID({ dispatch }){
      var _dispatch = dispatch;
      _dispatch('fetchProfile');
    },

    changePassword({ commit }, data){
        return new Promise((resolve, reject) => {
          axios.post('/applicants/me/changepassword/', data)
          .then((response) => {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },

    resetPassword({commit},object){
      return new Promise((resolve, reject) =>{
        axios.post('/passwordreset/', object)
        .then(function(response){
          resolve(response);
        })
        .catch(function(error){
          reject(error);
        })
      })
    },

    isTokenValid({commit}, token){
      return new Promise((resolve, reject) => {
        axios.get('/passwordreset/'+token)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      })
    },

    newPassword({commit}, payload){
      return new Promise((resolve, reject) =>{
        axios.put('passwordreset/' + payload.token, { password: payload.password})
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      })
    },
    updateEmail ({ state, commit, dispatch }, updateObj) {
      return axios_new_api.post('applicants/updateEmailAddress', updateObj, {
        headers: {
          //have to use another header bc axios.default is set
          'BankIdAuthorization': updateObj.code
        }
      })
        .then((response) => {
          return response;
        });
    },
  },

  // mutations
  mutations : {
    setProfile (state, profile) {
      state.profile = profile;
      // sessionStorage.setItem(auth.AUTH_USER_NAME_KEY, profile.firstName + ' ' +profile.lastName);
    },

    setContactID (state, profile){
      state.contactID = profile.contactCode;
    },

    setRules (state, data){
      state.rules = data;
    },

    setUser(state, user){
      state.user = user;
    }
  }
};
